import React from 'react';
import './viewallMessage.scss';
import { faEdit, faSearch, faTimesCircle, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Outlet } from 'react-router';
import { NavLink } from 'react-router-dom';
import { useDashboardContext } from '../../context';
import { useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import CustomToast from '../../../../components/Toast';
import ConfirmationModal from '../../../../components/ConfirmationPopUp';
import deleteMenu from '../../../../assets/images/deleteMenu.png';
import { useGlobalContext } from '../../../../globalContext';

const Index = (props) => {
  const {
    updateEmailModal,
    setUpdateEmailModal,
    sendEmailModal,
    setSendEmailModal,
    activeButton,
    setActiveButton,
    deleteHandler,
    messageBulktDeleteHandler,
    setMessageDetail,
    messageDetail,
    limit,
    setLimit,
    skip,
    setSkip,
    getEmailAsync,
    email,
    setIsReplayMessage,
    setSlectedStudents
  } = useDashboardContext();

  const { 
    notViewedAlerts,
    setAllMessage,
    allMessage,
    getMessageCountAsync,
    getAllAlertsAsync
  } = useGlobalContext();
  
  const [searchValue, setSearchValue] = React.useState('');
  const [isSent, setIsSent] = React.useState(false);
  const [deleteConfirmationContent, setDeleteConfirmationContent] = React.useState('');
  const [showDeleteConfirmationNotification, setShowDeleteConfirmationNotification] =
    React.useState(false);

  const location = useLocation();
  const isSentMessages = location.pathname.endsWith('/sent');

  React.useEffect(() => {
    setIsSent(isSentMessages);
  }, [isSentMessages]);

  React.useEffect(() => {
    const filteredData = allMessage.filter((item) => {
      if (activeButton === 'Date') {
        return item.tStamp; // replace this with your desired filter condition based on Date
      } else if (activeButton === 'From') {
        return item.fromUserID; // replace this with your desired filter condition based on From
      } else if (activeButton === 'Subject') {
        return item.subject; // replace this with your desired filter condition based on Subject
      }
    });
    setAllMessage(filteredData);
    getMessageCountAsync();
    getEmailAsync();
  }, []);

  const handleButtonClick = (buttonName) => {
    setLimit(10);
    setSkip(0);
    setActiveButton(buttonName);
    setSearchValue('');
    messageDetail.allInboxChecked = false;
  };

  const handleCheckAll = () => {
    if (messageDetail.allInboxChecked) {
      // If "Select All" checkbox is already checked, uncheck it and clear selectedMessages array
      setMessageDetail({
        ...messageDetail,
        selectedMessages: [],
        allInboxChecked: false
      });
    } else {
      // If "Select All" checkbox is not checked, check it and add all messages to selectedMessages array
      const allMessagesIds = allMessage.map((message) => message.alertID);
      setMessageDetail({
        ...messageDetail,
        selectedMessages: allMessagesIds,
        allInboxChecked: true
      });
    }
  };

  const clearAllHanlder = () => {
    setMessageDetail({
      ...messageDetail,
      selectedMessages: [],
      allInboxChecked: false
    });
    setActiveButton('Date');
    setSearchValue('');
    const isSentMessages = location.pathname.endsWith('/sent');
    if (isSentMessages) {
      getAllAlertsAsync(2, 'Date', '', limit, skip);
    } else {
      getAllAlertsAsync(1, 'Date', '', limit, skip);
    }
  };

  const deletedCheckedMessageHandler = () => {
    if (messageDetail.selectedMessages.length > 1 || messageDetail.allInboxChecked) {
      setShowDeleteConfirmationNotification(true);
      setDeleteConfirmationContent(
        'Are you sure that you want to delete the checked messages? The operation cannot be UNDONE!'
      );
    } else if (messageDetail.selectedMessages.length == 1) {
      setShowDeleteConfirmationNotification(true);
      setDeleteConfirmationContent(
        'Are you sure that you want to delete the checked message? The operation cannot be UNDONE!'
      );
    } else {
      CustomToast('You have not selected any messages to delete.', 'info');
    }
    return;
  };

  const deleteConfirmation = async (confirmMsg) => {
    setShowDeleteConfirmationNotification(false);
    const isSentMessages = location.pathname.endsWith('/sent');
    if (confirmMsg) {
      if (messageDetail.selectedMessages.length > 1 || messageDetail.allInboxChecked) {
        try {
          await messageBulktDeleteHandler();
          if (isSentMessages) {
            await getAllAlertsAsync(2, activeButton, searchValue, limit, skip);
          } else {
            await getAllAlertsAsync(1, activeButton, searchValue, limit, skip);
            await getMessageCountAsync();
          }
          messageDetail.selectedMessages = [];
          messageDetail.allInboxChecked = false;
        } catch (error) {
          console.log(error);
        }
      } else if (messageDetail.selectedMessages.length == 1) {
        try {
          await deleteHandler(messageDetail.selectedMessages);
          if (isSentMessages) {
            await getAllAlertsAsync(2, activeButton, searchValue, limit, skip);
          } else {
            await getAllAlertsAsync(1, activeButton, searchValue, limit, skip);
            await getMessageCountAsync();
          }
          messageDetail.selectedMessages = [];
        } catch (error) {
          console.log(error);
        }
      }
    }
  };

  // Set the debounce delay (in milliseconds)
  const debounceDelay = 500;

  const debounce = (func, delay) => {
    let timer;
    return function () {
      const context = this;
      const args = arguments;
      clearTimeout(timer);
      timer = setTimeout(function () {
        func.apply(context, args);
      }, delay);
    };
  };

  const searhHandler = async (value) => {
    const searchValue = value;
    const isSentMessages = location.pathname.endsWith('/sent');

    try {
      // Perform the API call after the debounce delay
      if (isSentMessages) {
        const response = await getAllAlertsAsync(2, '', searchValue, limit, skip);
        // Handle the response data here (e.g., set it in state)
        console.log(response);
      } else {
        const response = await getAllAlertsAsync(1, '', searchValue, limit, skip);
        // Handle the response data here (e.g., set it in state)
        console.log(response);
      }
    } catch (error) {
      // Handle any errors that may occur during the API call
      console.error(error);
    }
  };

  // Create a debounced function that calls the API
  const debouncedApiCall = debounce(searhHandler, debounceDelay);

  const handleSearchChange = (value) => {
    const inputValue = value;
    setSearchValue(inputValue);
    setSkip(0);

    debouncedApiCall(inputValue);
  };

  const sendHandler = () => {
    // setActiveButton('Date');
    setSearchValue('');
    setSkip(0);

    setMessageDetail({
      ...messageDetail,
      allInboxChecked: false,
      selectedMessages: []
    });
  };

  const inboxHandler = () => {
    // setActiveButton('Date');
    setSearchValue('');
    setSkip(0);
    setMessageDetail({
      ...messageDetail,
      allInboxChecked: false,
      selectedMessages: []
    });
  };

  return (
    <div onScroll={() => alert('sdaf')} className="white-card">
      <div className="row align-items-center mb-3">
        <div className="col-md-3">
          <h2 className="primary-title mb-md-0">
            Messages{' '}
            {location.pathname.endsWith('/inbox') && (
              <span className="text-muted">{`(${notViewedAlerts || 0})`}</span>
            )}
          </h2>
        </div>
        <div className="col-md-9 d-flex flex-column flex-sm-row  justify-content-between justify-content-md-end align-items-center">
          <button
            onClick={() => setUpdateEmailModal(!updateEmailModal)}
            className="btn edit-email-btn me-sm-3 mb-3 mb-sm-0">
            {email}
            <FontAwesomeIcon className="ms-2" icon={faEdit} />
          </button>
          <button
            onClick={() => {
              setSendEmailModal(!sendEmailModal);
              setIsReplayMessage(false);
              setSlectedStudents([]);
            }}
            className="btn btn-castleRed">
            Compose Message
          </button>
        </div>
      </div>
      <div className="row message-tab align-items-center mb-3">
        <div className="col-md-4">
          <div className="primary-tab d-md-block mb-md-0">
            <div className="btn-group">
              <NavLink onClick={inboxHandler} className="btn" to="inbox">
                {' '}
                Inbox{' '}
              </NavLink>
              <NavLink onClick={sendHandler} className="btn" to="sent">
                {' '}
                Sent{' '}
              </NavLink>
            </div>
          </div>
        </div>
        <div className="col-md-8 col-lg-5">
          <div className="d-flex flex-column flex-sm-row justify-content-md-end align-items-sm-center">
            <label className="form-label me-3 mb-sm-0">Sort by:</label>
            <div className="primary-tab blue-tab mb-0">
              <div className="btn-group">
                <button
                  className={`btn ${activeButton === 'Date' ? 'active' : ''}`}
                  onClick={() => handleButtonClick('Date')}>
                  Date
                </button>
                {/* <button
                  className={`btn ${activeButton === 'From' ? 'active' : ''}`}
                  onClick={() => handleButtonClick('From')}>
                  From
                </button> */}
                <button
                  className={`btn ${activeButton === 'Subject' ? 'active' : ''}`}
                  onClick={() => handleButtonClick('Subject')}>
                  Subject
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-3 mt-3 mt-lg-0">
          <div className="custom-search position-relative">
            <FontAwesomeIcon icon={faSearch} />
            <input
              type="text"
              placeholder="Search Message"
              className="form-control"
              id="search"
              value={searchValue}
              onChange={(e) => handleSearchChange(e.target.value)}
            />
          </div>
        </div>
      </div>

      <div className="col-12 message-filter py-3 d-flex flex-wrap gap-3 justify-content-between mb-3">
        <div className="form-check d-flex align-items-center">
          <input
            className="form-check-input d-none"
            type="checkbox"
            value=""
            id="flexCheckDefault"
            onClick={handleCheckAll}
            checked={messageDetail.allInboxChecked ? true : false}
          />
          <label className="form-check-label ms-3 d-none">Check All</label>
        </div>

        <div className="d-flex gap-3 flex-wrap">
          <button onClick={clearAllHanlder} className="btn-link secondary-link">
            <FontAwesomeIcon className="me-2" icon={faTimesCircle} />
            Clear All{' '}
          </button>
          <button onClick={deletedCheckedMessageHandler} className="btn-link primary-link">
            <FontAwesomeIcon className="me-2" icon={faTrashAlt} />
            Delete Checked Messages
          </button>
        </div>
      </div>
      <Outlet />
      <ConfirmationModal
        isOpen={showDeleteConfirmationNotification}
        onClose={() => deleteConfirmation(false)}
        onSave={() => deleteConfirmation(true)}
        contentWidth={'35%'}
        buttonPosition={'center'}
        content={deleteConfirmationContent}
        cancelButton={'No'}
        confirmButton={'Yes'}
        showIcon={true}
        icon={deleteMenu}
      />
    </div>
  );
};

Index.propTypes = {
  messageCount: PropTypes.object,
  allMessageCount: PropTypes.object
};

export default Index;
